import type { FaireProductEntity } from "../../entity_types/product";

export const p_qf579kfurv: FaireProductEntity = {
  token: "p_qf579kfurv",
  type: "product",
  name: "Lavender Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d25dc4ddf7e2df72e253409e9fb4321b3491b8d86317f03efc18b7d9b24bc7e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6ba658a7ac2761368cfbdad60d50c916479df261dbd7eb485d77fd5961bd915.jpeg",
    "https://cdn.faire.com/fastly/8e40bbc0e7c560f2113faf992434fc69f1df7b687d3a1406902fa03c9187dcee.jpeg",
    "https://cdn.faire.com/fastly/981095c254ff088e2d2e7913ab38a51ab0e99ccf2a1299750aaac070f88b77e4.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:53.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
